import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card, Avatar, CardHeader, CardContent, Box, Link, Typography, Icon, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { VeterinaryContact } from '../models/vets';

interface VeterinaryContactCardProps {
  contact: VeterinaryContact;
  action: React.ReactElement;
}

const useStyles = makeStyles(() =>
  createStyles({
    headerText: {
      display: 'flex',
      alignItems: 'center'
    },
    cardContent: {
      paddingTop: 0
    }
  })
);

const VeterinaryContactCard = ({ contact, action }: VeterinaryContactCardProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const renderContactCardTitle = () => {
    return contact.isPrimary ? (
      <div className={classes.headerText}>
        <Typography variant="body2">{contact.name}</Typography>
        <Icon color="primary" fontSize="small">
          {'star'}
        </Icon>
      </div>
    ) : (
      contact.name
    );
  };

  return (
    <Box width={1}>
      <Card elevation={1}>
        <CardHeader
          avatar={<Avatar color="primary">{contact.name[0]}</Avatar>}
          action={action}
          title={renderContactCardTitle()}
          subheader={contact.udaNumber}
        />
        <CardContent className={classes.cardContent}>
          <Grid container>
            {contact.email && (
              <Grid item md={8} xs={12}>
                <Typography variant="subtitle2">{t('f-com-email')}</Typography>
                <Link href={`mailto:${contact.email}`} variant="body1">
                  {contact.email}
                </Link>
              </Grid>
            )}

            {contact.phone && (
              <Grid item md={8} xs={12}>
                <Typography variant="subtitle2">{t('f-com-phone')}</Typography>
                <Link href={`tel:${contact.phone}`} variant="body1">
                  {contact.phone}
                </Link>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default VeterinaryContactCard;
